import { ButtonVoltar } from "../../../../components";
import { Grid, Skeleton, Box, Typography } from "@mui/material";
import DadosBancarios from "../../../../components/DadosBancarios";
import useStyles from "./styles";
import { Titulo } from "../../../../components";
export default function MeusDadosBancarios({ handlerCancelEdit }) {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Grid container className={classes.container}>
        {/* Cabeçalho */}
        <Grid item xs={12} className={classes.header}>
          <Box display="flex" alignItems="center" mb={2}>
            <ButtonVoltar handleVoltar={handlerCancelEdit} mostraTexto={true} />
          </Box>
          <Titulo variant="h5" className={classes.title}>
            Meus dados bancários
          </Titulo>
        </Grid>

        {/* Conteúdo principal */}
        <Grid item xs={12}>
          <DadosBancarios />
        </Grid>
      </Grid>
    </Box>
  );
}
